import {useTranslation} from "react-i18next";
import EntityCRUDTable from "./EntityCRUDTable";
import React, {useState, useEffect} from "react";
import TextField from "@mui/material/TextField";
import {questionnaireFormCRUD} from "../../../http";
import {MenuItem} from "@mui/material";
import {getFilials, getDepartments} from "../../../redux/actions";

export default function QuestionnaireFormCRUDTable({...props}) {
    const {t} = useTranslation();
    const [entity, setEntity] = useState({
        name: "",
        nameKz: "",
        type: 1,
        level: 0,
        parentId: null
    });
    const [parentForms, setParentForms] = useState([]);

    const setValue = (key, value) => {
        setEntity({...entity, [key]: value});
    };

    const clearEntity = () => {
        setEntity({
            name: "",
            nameKz: "",
            type: 1,
            level: 0,
            parentId: null
        });
    };

    useEffect(() => {
        const loadParentForms = async () => {
            try {
                const response = await questionnaireFormCRUD.search({
                    paging: {pageNumber: 1, pageSize: 1000, returnCount: false},
                    filter: {},
                    sort: {name: {operator: "asc", ordinal: 0}}
                });
                setParentForms(response.result || []);
            } catch (error) {
                console.error("Ошибка загрузки родительских форм:", error);
            }
        };
        loadParentForms();
    }, []);

    const columns = [
        {title: "ID", dataIndex: "id", key: "id"},
        {title: t("questionnaireForm.name") || "Название", dataIndex: "name", key: "name"},
        {title: t("questionnaireForm.nameKz") || "Название (KZ)", dataIndex: "nameKz", key: "nameKz"},
        {title: t("questionnaireForm.type") || "Тип", dataIndex: "type", key: "type"},
        {title: t("questionnaireForm.level") || "Уровень", dataIndex: "level", key: "level"},
        {
            title: t("questionnaireForm.parent") || "Родительская форма",
            dataIndex: ["parent", "name"],
            key: "parentName",
            render: (value) => value || "-"
        },
    ];


    const filterFields = [
        {
            title: "Год (от)",
            key: "createdAt",
            operandPosition: 1,
            compareType: "between",
            type: "date2",
            filterType: "normal",
        },
        {
            title: "Год (до)",
            key: "createdAt",
            operandPosition: 2,
            compareType: "between",
            type: "date2",
            filterType: "normal",
        },
        {
            title: "Филиал",
            key: "filialId",
            compareType: "equals",
            reducerKey: "filial",
            reducerArrayKey: "filials",
            reducerAction: getFilials,
            operandPosition: 1,
            optionLabelKey: "name",
            type: "normal",
            filterType: "normal",
        },
        {
            title: "Лаборатория",
            key: "departmentId",
            compareType: "equals",
            reducerKey: "department",
            reducerArrayKey: "departments",
            reducerAction: getDepartments,
            operandPosition: 1,
            optionLabelKey: "name",
            type: "normal",
            filterType: "normal",
        },
    ];

    const createFields = [
        <TextField
            margin="normal"
            value={entity.name}
            onChange={(e) => setValue("name", e.target.value)}
            fullWidth
            id="name"
            name="name"
            label={t("questionnaireForm.name") || "Название"}
            required
        />,
        <TextField
            margin="normal"
            value={entity.nameKz}
            onChange={(e) => setValue("nameKz", e.target.value)}
            fullWidth
            id="nameKz"
            name="nameKz"
            label={t("questionnaireForm.nameKz") || "Название (KZ)"}
            required
        />,
        <TextField
            margin="normal"
            value={entity.type}
            onChange={(e) => setValue("type", parseInt(e.target.value))}
            fullWidth
            select
            id="type"
            name="type"
            label={t("questionnaireForm.type") || "Тип"}
            required
        >
            <MenuItem value={1}>Boolean (1)</MenuItem>
        </TextField>,
        <TextField
            margin="normal"
            value={entity.level}
            onChange={(e) => setValue("level", parseInt(e.target.value) || 0)}
            fullWidth
            type="number"
            id="level"
            name="level"
            label={t("questionnaireForm.level") || "Уровень"}
            required
        />,
        <TextField
            margin="normal"
            value={entity.parentId || ""}
            onChange={(e) => setValue("parentId", e.target.value ? parseInt(e.target.value) : null)}
            fullWidth
            select
            id="parentId"
            name="parentId"
            label={t("questionnaireForm.parentId") || "Родительская форма"}
        >
            <MenuItem value="">Нет родителя</MenuItem>
            {parentForms.map((form) => (
                <MenuItem key={form.id} value={form.id}>
                    {form.name} (ID: {form.id}, Level: {form.level})
                </MenuItem>
            ))}
        </TextField>,
    ];

    const editFields = [
        <TextField
            margin="normal"
            value={entity.name || ""}
            onChange={(e) => setValue("name", e.target.value)}
            fullWidth
            id="name"
            name="name"
            label={t("questionnaireForm.name") || "Название"}
            required
        />,
        <TextField
            margin="normal"
            value={entity.nameKz || ""}
            onChange={(e) => setValue("nameKz", e.target.value)}
            fullWidth
            id="nameKz"
            name="nameKz"
            label={t("questionnaireForm.nameKz") || "Название (KZ)"}
            required
        />,
        <TextField
            margin="normal"
            value={entity.type || 1}
            onChange={(e) => setValue("type", parseInt(e.target.value))}
            fullWidth
            select
            id="type"
            name="type"
            label={t("questionnaireForm.type") || "Тип"}
            required
        >
            <MenuItem value={1}>Boolean (1)</MenuItem>
        </TextField>,
        <TextField
            margin="normal"
            value={entity.level || 0}
            onChange={(e) => setValue("level", parseInt(e.target.value) || 0)}
            fullWidth
            type="number"
            id="level"
            name="level"
            label={t("questionnaireForm.level") || "Уровень"}
            required
        />,
        <TextField
            margin="normal"
            value={entity.parentId || ""}
            onChange={(e) => setValue("parentId", e.target.value ? parseInt(e.target.value) : null)}
            fullWidth
            select
            id="parentId"
            name="parentId"
            label={t("questionnaireForm.parentId") || "Родительская форма"}
        >
            <MenuItem value="">Нет родителя</MenuItem>
            {parentForms.map((form) => (
                <MenuItem key={form.id} value={form.id}>
                    {form.name} (ID: {form.id}, Level: {form.level})
                </MenuItem>
            ))}
        </TextField>,
    ];

    const detailsFields = [
        <TextField
            margin="normal"
            value={entity.name || ""}
            fullWidth
            id="name"
            name="name"
            label={t("questionnaireForm.name") || "Название"}
            disabled
        />,
        <TextField
            margin="normal"
            value={entity.nameKz || ""}
            fullWidth
            id="nameKz"
            name="nameKz"
            label={t("questionnaireForm.nameKz") || "Название (KZ)"}
            disabled
        />,
        <TextField
            margin="normal"
            value={entity.type || ""}
            fullWidth
            id="type"
            name="type"
            label={t("questionnaireForm.type") || "Тип"}
            disabled
        />,
        <TextField
            margin="normal"
            value={entity.level || ""}
            fullWidth
            id="level"
            name="level"
            label={t("questionnaireForm.level") || "Уровень"}
            disabled
        />,
        <TextField
            margin="normal"
            value={entity.parentId ? `${entity.parent?.name || `ID: ${entity.parentId}`}` : "Нет родителя"}
            fullWidth
            id="parentId"
            name="parentId"
            label={t("questionnaireForm.parentId") || "Родительская форма"}
            disabled
        />,
    ];

    const removeFields = [
        <TextField
            margin="normal"
            value={entity.name || ""}
            fullWidth
            id="name"
            name="name"
            label={t("questionnaireForm.name") || "Название"}
            disabled
        />,
        <TextField
            margin="normal"
            value={entity.nameKz || ""}
            fullWidth
            id="nameKz"
            name="nameKz"
            label={t("questionnaireForm.nameKz") || "Название (KZ)"}
            disabled
        />,
    ];

    return <EntityCRUDTable
        entityType="questionnaireForm"
        columns={columns}
        filterFields={filterFields}
        entity={entity}
        setEntity={setEntity}
        setValue={setValue}
        clearEntity={clearEntity}
        createFields={createFields}
        editFields={editFields}
        detailsFields={detailsFields}
        removeFields={removeFields}
        createEntityTitle={t("questionnaireForm.create") || "Добавление формы анкеты"}
        editEntityTitle={t("questionnaireForm.edit") || "Редактирование формы анкеты"}
        detailsEntityTitle={t("questionnaireForm.details") || "Просмотр формы анкеты"}
        removeEntityTitle={t("questionnaireForm.remove") || "Удаление формы анкеты"}
        {...props}
    />;
}
